<template>
	<div>
		<el-button
			v-if="isShowPayBtn"
			:icon="btnIcon"
			:loading="isShowLoading"
			:type="btnType"
			size="mini"
			@click="onStartPay">
			{{ btnText }}
		</el-button>
		<el-tag v-else style="margin: 0 6px" type="warning">对公处理中</el-tag>
		<el-button
			v-if="isShowRefresh"
			:loading="isShowLoading"
			icon="el-icon-refresh"
			size="mini"
			type="text"
			@click="onRefresh">
			刷新
		</el-button>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import PayOffLineDialog from '@/views/insurance/product/common/payOffLineDialog'
import {canPayOffline, getPayStatus, getPolicyDetails, pay} from '@/views/insuranceCenter/api/insureApiNew'
import {isAnZeProduct} from '@/util/productUtil'
import {payToHint} from '@/util/insureUtils'
import sensorsUtils from '@/util/sensorsUtils'

export default {
	name: 'payBtn',
	mixins: [],
	components: {PayOffLineDialog},
	props: {
		payBtnDataTemp: {
			type: Object,
			required: true,
		},
		insureType: String | Number,
	},
	data() {
		return {
			isShowPayBtn: true,
			isShowLoading: false,
			payHint: false,
			payBtnData: this.payBtnDataTemp,
			btnText: '',
			btnIcon: '',
			btnType: '',
			payOrderId: '',
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
		isShowRefresh() {
			return this.payBtnData && this.payBtnData.isIndex
		},
	},
	watch: {
		payBtnDataTemp: {
			handler(newVal, oldVal) {
				if (!this.validatenull(newVal) && newVal !== oldVal) {
					let {paySource, certFile} = newVal
					if (paySource == 2) {
						//对公支付
						if (this.validatenull(certFile) || certFile == oldVal.certFile) {
							return
						}
					}
					this.payBtnData = newVal
					this.initBtn()
				}
			},
			deep: true,
		},
	},
	methods: {
		initBtn() {
			if (!this.validatenull(this.payBtnData)) {
				this.btnType = 'text'
				this.isShowPayBtn = true
				//isIndex 是否为列表
				let {paySource, certFile, isIndex} = this.payBtnData
				paySource = `${paySource}`
				//显示btn
				if (paySource === '1') {
					this.btnText = '在线支付'
					this.btnIcon = isIndex ? 'el-icon-check' : ''
					if (!isIndex) {
						this.btnType = 'warning'
					}
				} else if (paySource === '2') {
					//对公支付
					if (this.validatenull(certFile)) {
						//为空，则没有支付
						this.btnText = '对公支付'
						if (!isIndex) {
							this.btnType = 'warning'
						}
					} else {
						this.isShowPayBtn = false
					}
					this.btnIcon = isIndex && !certFile ? 'el-icon-check' : ''
				}
			}
		},
		onStartPay() {
			//开始支付
			this.onDealCustom(true)

			//加埋点
			this.onAddTrackEvent('支付保单')
		},
		//抽离
		async onDealCustom(isPay = false) {
			let {
				paySource,
				productId,
				sourceProductId,
				insureType,
				orderId,
				isAdd = false,
				currentOderId: oldCurrentOrderId,
			} = this.payBtnData
			paySource = `${paySource}`
			if (this.validatenull(orderId)) {
				this.$message.error('数据有误')
				return
			}
			this.isShowLoading = true
			try {
				//处理orderId
				if (paySource === '1' && orderId.length < 10 && this.validatenull(this.payOrderId)) {
					this.payOrderId = await getPolicyDetails(this.payBtnData.orderId).then((response) => {
						return response.data.data.payOrderId
					})
				} else if (orderId.length > 10) {
					this.payOrderId = orderId
				}
				//支付
				if (isPay) {
					if (paySource === '1') {
						//在线支付
						let resPay = (await pay(this.payOrderId, '', insureType)) || {}
						let {data: {payUrl = '', payType = ''} = {}, originCode = '0'} = resPay.data
						if (isAnZeProduct(insureType) && (originCode === '210' || originCode === '214')) {
							this.$alert('该保单需要保司在线核保确认后才可以进行支付等后续流程，请稍后再次尝试支付！', '提示', {
								confirmButtonText: '知道了',
							}).then(() => {})
							return
						}
						this.$nextTick(() => {
							//订单id
							let currentOrderId = this.payBtnData.currentOderId ? this.payBtnData.currentOderId : '1'
							payToHint({payOrderId: this.payOrderId, payUrl, insureType, orderId: currentOrderId, payType})
						})
					} else {
						// this.$refs.payOffLine.dealData(this.payBtnData)
						let queryOffline = {
							pid: sourceProductId,
						}
						if (productId) {
							queryOffline.npid = productId
						}
						if (isAdd && oldCurrentOrderId) {
							queryOffline.orderId = oldCurrentOrderId
						}
						//检测是否可以支付
						await canPayOffline(queryOffline, insureType)
						this.$emit('onToOfflinePay', this.payBtnData)
					}
				} else {
					if (paySource === '1') {
						//刷新
						await getPayStatus(this.payOrderId)
						this.$emit('onPayOffLineSuccess')
					} else {
						this.$message.success('刷新成功')
						this.$emit('onPayOffLineSuccess', 'refresh')
					}
				}
			} catch (e) {
				this.$alert(e.message || '支付异常', '提示', {
					confirmButtonText: '确定',
				}).then(() => {})
			} finally {
				if (paySource === '1') {
					this.isShowLoading = false
				} else {
					setTimeout(() => {
						this.isShowLoading = false
					}, 2000)
				}
			}
		},
		onRefresh() {
			//刷新结果
			this.onDealCustom()

			//加埋点
			this.onAddTrackEvent('刷新保单')
		},

		/**
		 * 加埋点
		 * @param button_name 按钮名称
		 */
		onAddTrackEvent(button_name) {
			let {orderId} = this.payBtnData
			//加埋点
			sensorsUtils.trackEvent('policy_search_function_operate_click', {
				button_name,
				order_id: orderId,
			})
		},
	},
	created() {},
	mounted() {
		this.initBtn()
	},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
//style="padding: 4px 12px !important;"
.hint_content {
	display: block;
	text-align: center;
	font-size: 16px;
}
</style>
